<template>
  <div class="apply_financing" >
    <a @click="toApply" >
      <img src="../static/img/rz.png" alt="我要融资" />
      <div>申请融资</div>
    </a>
  </div>
</template>

<script>
export default {
    methods:{
        toApply(){
            window.location = 'http://xt.zcd.guoguyun.com/zcd/admin.html?applyFinancing'
        }
    }
};
</script>

<style>
.apply_financing {
  position: fixed;
  bottom: 130px;
  right: 120px;
  width: 120px;
  height: 120px;
  background: linear-gradient(43deg, #2f57f4, #3e95f2);
  text-align: center;
  border-radius: 10px;
  font-size: 15px;
  box-shadow: 1px 12px 25px 2px rgba(53, 112, 243, 0.28);
}

.apply_financing a {
  display: inline-block;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 15px;
  color: #fff !important;
}
</style>


// WEBPACK FOOTER //
// src/components/ApplyFinancing.vue